module.exports = __webpack_public_path__ + "img/720-aeeb6d.png";